import React from "react";
import { Text, View } from "react-native";
import LanguageSection from "./language-section";

const General = () => {
  return (
    <View className="flex-col">
      <LanguageSection />
    </View>
  );
};

export default General;
